import { Footer } from '../components/Layout/Footer';
import { Welcome } from '../components/Welcome/Welcome';

export function HomePage() {
  return (
    <>
      <Welcome />
      <Footer />
    </>
  );
}
